import Extend from 'flarum/common/extenders';
import RelatedGambit from './query/RelatedGambit';
export default [new Extend.Search() //
.gambit('discussions', RelatedGambit)];